/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const { project } = feature;

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
    http_start()`,
    });

    blocks.push({
        location: 'on_sys_timer',
        blockType: BlockType.CODE,
        template: '    http_proc_timer()',
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_http_reponse_code_arrival',
        template: `
sub callback_http_reponse_code_arrival(http_response as string)
    '****callback_http_reponse_code_arrival****'
end sub
`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_http_request_failed',
        template: `
sub callback_http_request_failed(byref error_message as string)
    '****callback_http_request_failed****'
end sub
`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_http_header_arrival',
        template: `
sub callback_http_header_arrival(byref header_type as string, byref header_value as string)
    '****callback_http_header_arrival****'
end sub
`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_http_headers_complete',
        template: `
sub callback_http_headers_complete()
    '****callback_http_headers_complete****'
end sub
`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_http_content_arrival',
        template: `
sub callback_http_content_arrival(byref data as string)
    '****callback_http_content_arrival****'
end sub
`,
    });


    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_http_post_data_sent_ok',
        template: `
sub callback_http_post_data_sent_ok()
    '****callback_http_post_data_sent_ok****'
end sub
`,
    });

    blocks.push({
        location: 'on_sock_event',
        blockType: BlockType.CODE,
        template: `
    http_sock_state_update(newstatesimple)`,
    });

    blocks.push({
        location: 'on_sock_data_arrival',
        blockType: BlockType.CODE,
        template: `
    http_proc_data()`,
    });

    blocks.push({
        location: 'on_sock_data_sent',
        blockType: BlockType.CODE,
        template: `
    http_on_sock_data_sent()`,
    });


    blocks.push({
        location: 'callback_dns_answer_acquired',
        blockType: BlockType.CODE,
        template: `
    http_dns_answer_acquired(return_type, return_string)`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_http_send_post_data',
        template: `
sub callback_http_send_post_data(remaining_content_length as dword)
    '****callback_http_send_post_data****'
end sub
`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_http_send_headers',
        template: `
sub callback_http_send_headers()
    '****callback_http_send_headers****'
end sub
`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_http_request_complete',
        template: `
sub callback_http_request_complete()
    '****callback_http_request_complete****'
end sub
`,
    });


    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_http_response_code_arrival',
        template: `
sub callback_http_response_code_arrival(byref http_response as string)
    '****callback_http_response_code_arrival****'
end sub
`,
    });


    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_http_open_romfile',
        template: `
function callback_http_open_romfile() as dword
    callback_http_open_romfile=0
    '****callback_http_open_romfile****'
end function
`,
    });

    return blocks;
};
